import { Component, Input } from '@angular/core';

import { CarOptionsShort } from './car-options-short';

@Component({
  standalone: false,
  selector: 'car-options-short',
  templateUrl: './car-options-short.component.html'
})
export class CarOptionsShortComponent {

  @Input()
  public options: CarOptionsShort;

  constructor() { }
}
